import { useMemo } from 'react';
import type { InfiniteData } from '@tanstack/react-query';

import type { VehicleListFetcher } from '../useFetchVehicleList/useFetchVehicleList.types';

import { getCurrentPage } from './useVehicleListCurrentPage.helpers';

const useVehicleListCurrentPage = (vehicles?: InfiniteData<VehicleListFetcher>): number =>
	useMemo(() => getCurrentPage(vehicles), [vehicles]);

export default useVehicleListCurrentPage;
